import { Chip, Stack, SxProps, Tooltip } from "@mui/material";
import typography from "constants/typography.constants";
import { getCompetencyMapAssesmentTypeString } from "helpers/competencyMap.helpers";
import { gradeColor, secondsToMinutes } from "helpers/index";
import palette from "theme/palette";
import { CompetencyMapWithProgressInfo } from "../../ProgressInfo/types";

interface ChipInfoProps {
  competencyMapWithProgressInfo: CompetencyMapWithProgressInfo | undefined;
}

const ChipInfo = ({ competencyMapWithProgressInfo }: ChipInfoProps) => {
  const { grades } = competencyMapWithProgressInfo || {};

  const chipBaseSx: SxProps = {
    py: 0.65,
    height: "fit-content",
    width: "fit-content",
  };

  return (
    <Stack
      direction='row'
      spacing={1}
      useFlexGap
      justifyContent='flex-end'
      sx={{ flexWrap: "wrap" }}>
      <Stack
        direction='row'
        spacing={1}
        useFlexGap>
        {!!grades?.length && (
          <Stack
            direction='row'
            spacing={1}>
            {grades?.map((grade) => (
              <Chip
                key={grade}
                label={grade}
                sx={{
                  backgroundColor: `${gradeColor(grade)}.light`,
                  color: `${gradeColor(grade)}.contrast`,
                  ...chipBaseSx,
                }}
              />
            ))}
          </Stack>
        )}
      </Stack>
      <Stack
        direction='row'
        spacing={1}
        useFlexGap>
        <Tooltip
          title={
            <span>
              Продолжительность тестирования.
              <br />
              {typography.testing.table.scoringType}:
              <b>{getCompetencyMapAssesmentTypeString(competencyMapWithProgressInfo?.questionsTime)}</b>
            </span>
          }>
          <Chip
            label={secondsToMinutes(competencyMapWithProgressInfo?.questionsTime, "00:00:00")}
            sx={{
              backgroundColor: palette.status.created,
              color: palette.white,
              ...chipBaseSx,
            }}
          />
        </Tooltip>
        <Chip
          label={
            <>
              Всего вопросов: <b>{competencyMapWithProgressInfo?.confirmedQuestionsCount}</b>
            </>
          }
          sx={{
            backgroundColor: palette.status.created,
            color: palette.white,
            ...chipBaseSx,
          }}
        />
      </Stack>
    </Stack>
  );
};

export default ChipInfo;
